exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-3377f146] {\n  cursor: pointer;\n}\n", ""]);

// exports
